var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.final_img)?_c('img',{staticClass:"result-img",attrs:{"src":_vm.final_img}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }